/* istanbul ignore file */
import styled from 'styled-components';
import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';

export const Container = styled.div`
  background: #D7F4FE;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column; /* Ensure title is on top */

  @media (max-width: 600px) {
    align-items: stretch;
    padding: 10px;
  }
`;

export const Title = styled.div`
  font-weight: 600;
  color: #1E194B;
  font-size: 18px;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

export const SaveRecordButton = styled(Button).attrs(({ id }) => ({
  id: id || 'save-record-button',
}))<{ turnSecondary?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
  width: 306px;
  height: 40px;
  background: ${({ turnSecondary }) => (turnSecondary ? '#F3F3F3' : '#002B5B')};
  border-radius: 8px;
  border: none;
  font-family: 'Museo Sans', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: ${({ turnSecondary }) => (turnSecondary ? '#1E194B' : '#FFFFFF')};

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const PatientRow = styled.div`
  display: flex;
  gap: 30px;
  font-size: 16px;
  color: #1E194B;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
  }
`;

export const WarningText = styled(Paragraph)`
  font-size: 14px;
  font-weight: 500;
  color: #8A8A8A;
  margin-bottom: 1rem;
  text-align: center;

  strong {
    color: #DC2626;
  }
`;

export const WarningTextRed = styled(WarningText)`
  color: red !important;
`;

export const Label = styled.span`
  font-weight: 600;
  margin-right: 4px;
`;

export const CompactButton = styled(Button)`
  display: flex;
  border: none;
  flex-direction: row;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
  width: 203px;
  background: #F3F3F3;
  border-radius: 8px;
  font-family: 'Museo Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #002B5C;

  &:hover {
    border: none;
  }

  white-space: normal;
  text-align: center;

  & > * {
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  @media (max-width: 600px) {
    width: 100%;
    margin-top: 10px;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const ModalText = styled(Paragraph)`
  font-size: 16px;
  font-weight: 500;
  color: #1E194B;
`;
